// extracted by mini-css-extract-plugin
export default {"taskItem":"taskItem___zRYoZ","taskInfo":"taskInfo___iNhQt"};